'use strict';

var defaultTheme = require('./defaultTheme-50f2b88f.js');
var React = require('react');
var nanoid = require('nanoid');
var styled = require('styled-components');
var lodash = require('lodash');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var checkboxSize = '18px';
var Checkbox$1 = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var CheckIcon = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 0;\n  transform: scale(0.1);\n  transition: all 200ms;\n  position: absolute;\n  width: 12px;\n  top: 4px;\n  left: 3px;\n  color: ", ";\n\n  svg {\n    width: 100%;\n    display: block;\n  }\n"])), function (props) {
  return props.theme.getColor('gray-100');
});
var IndeterminateCheckIcon = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n  opacity: 0;\n  transform: scale(0.1);\n  transition: all 200ms;\n  position: absolute;\n  height: 2px;\n  top: 8px;\n  left: 4px;\n  background: ", ";\n  width: 10px;\n"])), function (props) {
  return props.theme.getColor('gray-100');
});
var CheckboxLabel = styled__default['default'].label.attrs(defaultTheme.applyDefaultTheme)(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n  display: inline-flex;\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  min-height: ", ";\n  text-align: left;\n  flex-wrap: wrap;\n  flex: 1;\n  line-height: ", ";\n  margin-right: auto;\n\n  & input[type='checkbox'] {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n    margin: 0;\n  }\n\n  &::before {\n    content: '';\n    border: 2px solid ", ";\n    border-radius: 2px;\n    transition: all 200ms;\n    width: ", ";\n    height: ", ";\n    box-sizing: border-box;\n  }\n\n  &:has(input[type='checkbox']:checked) {\n    &::before {\n      background: ", ";\n      border-color: ", ";\n    }\n  }\n\n  &:has(input[type='checkbox']:not([data-indeterminate='true']):checked) {\n    ", " {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  &:has(input[type='checkbox'][data-indeterminate='true']:checked) {\n    ", " {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  ", "\n"])), checkboxSize, checkboxSize, function (props) {
  return props.theme.getColor('gray-300');
}, checkboxSize, checkboxSize, function (props) {
  return props.theme.getColor('emerald-500');
}, function (props) {
  return props.theme.getColor('emerald-500');
}, CheckIcon, IndeterminateCheckIcon, function (props) {
  return props.disabled && styled.css(_templateObject5 || (_templateObject5 = defaultTheme._taggedTemplateLiteral(["\n      opacity: 0.5;\n      cursor: not-allowed;\n    "])));
});
var CheckboxVisualLabel = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject6 || (_templateObject6 = defaultTheme._taggedTemplateLiteral(["\n  padding-left: 10px;\n  font-weight: 400;\n  font-size: 0.875rem;\n  flex: 1;\n\n  ", ";\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-600'));
});
var Description = styled__default['default'].p.attrs(defaultTheme.applyDefaultTheme)(_templateObject7 || (_templateObject7 = defaultTheme._taggedTemplateLiteral(["\n  margin: 0.375rem 0 0 0;\n  font-size: 0.75rem;\n  line-height: 1.333;\n\n  ", ";\n\n  ", "\n"])), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-400'), props.theme.getColor('gray-500'));
}, function (props) {
  return props.error && styled.css(_templateObject8 || (_templateObject8 = defaultTheme._taggedTemplateLiteral(["\n      content: 'error';\n      ", "\n    "])), props.theme.themeProp('color', props.theme.getColor('red-200'), props.theme.getColor('red-500')));
});

var Checkbox = React__default['default'].forwardRef(function Checkbox(_ref, forwardedRef) {
  var checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      name = _ref.name,
      value = _ref.value,
      description = _ref.description,
      error = _ref.error,
      indeterminate = _ref.indeterminate,
      label = _ref.label,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      className = _ref.className,
      style = _ref.style;

  var _useState = React.useState(nanoid.nanoid()),
      _useState2 = defaultTheme._slicedToArray(_useState, 1),
      uniqueId = _useState2[0];

  var hasError = React.useMemo(function () {
    if (lodash.isBoolean(error)) {
      return error;
    }

    return !lodash.isEmpty(error);
  }, [error]);
  var descriptionText = React.useMemo(function () {
    if (!lodash.isEmpty(error)) {
      return error;
    }

    if (!lodash.isEmpty(description)) {
      return description;
    }

    return null;
  }, [description, error]);
  var onClick = React.useCallback(function (event) {
    if (readOnly) {
      event.preventDefault();
    }
  }, [readOnly]);
  return React__default['default'].createElement(Checkbox$1, {
    className: className,
    style: style
  }, React__default['default'].createElement(CheckboxLabel, {
    disabled: disabled || readOnly,
    htmlFor: uniqueId,
    onClick: onClick
  }, React__default['default'].createElement("input", {
    ref: forwardedRef,
    id: uniqueId,
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    readOnly: readOnly,
    value: value,
    name: name,
    type: "checkbox",
    onChange: onChange,
    onBlur: onBlur,
    "data-indeterminate": indeterminate
  }), React__default['default'].createElement(IndeterminateCheckIcon, null), React__default['default'].createElement(CheckIcon, null, React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.9 8.45"
  }, React__default['default'].createElement("path", {
    d: "m3.68,8.45L0,4.75l1.21-1.21,2.47,2.45L9.7,0l1.21,1.23-7.22,7.22Z",
    fill: "currentColor"
  }))), (typeof label === 'string' && label.length > 0 || defaultTheme._typeof(label) === 'object') && React__default['default'].createElement(CheckboxVisualLabel, null, label)), typeof descriptionText === 'string' && descriptionText.length > 0 && React__default['default'].createElement(Description, {
    error: hasError
  }, descriptionText));
});
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  checked: defaultTheme.PropTypes.bool,
  defaultChecked: defaultTheme.PropTypes.bool,
  label: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.string, defaultTheme.PropTypes.element]),
  disabled: defaultTheme.PropTypes.bool,
  readOnly: defaultTheme.PropTypes.bool,
  name: defaultTheme.PropTypes.string,
  value: defaultTheme.PropTypes.string,
  description: defaultTheme.PropTypes.string,
  error: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.bool, defaultTheme.PropTypes.string]),
  indeterminate: defaultTheme.PropTypes.bool,
  onChange: defaultTheme.PropTypes.func,
  onBlur: defaultTheme.PropTypes.func,
  className: defaultTheme.PropTypes.string,
  style: defaultTheme.PropTypes.object
} : {};
Checkbox.defaultProps = {
  disabled: false,
  readOnly: false,
  indeterminate: false
};

exports.Checkbox = Checkbox;
